import { render } from "./TopBar.vue?vue&type=template&id=fca79236&scoped=true&ts=true&lang=pug"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=fca79236&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fca79236"]])

export default __exports__